import { render, staticRenderFns } from "./GuppyChatMessages.vue?vue&type=template&id=26904eda&scoped=true&"
import script from "./GuppyChatMessages.vue?vue&type=script&lang=js&"
export * from "./GuppyChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatMessages.vue?vue&type=style&index=0&id=26904eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26904eda",
  null
  
)

export default component.exports